
import {
  defineComponent, ref, reactive, onMounted,onUnmounted,
} from 'vue';
import { Tabs, message, } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { post, } from '@/request/request';

import OperateHeader from './components/operateHeader.vue';
import ListTable from './components/table.vue';
import singleStationTable from './components/singleStationTable.vue';
import ListChart from './components/charts.vue';
import singleStationChart from './components/singleStationChart.vue';
import downloadModal from './components/downloadModal.vue';

const { TabPane, } = Tabs;

export default defineComponent({
  components: {
    Tabs,
    TabPane,
    OperateHeader,
    ListTable,
    ListChart,
    downloadModal,
    singleStationChart,
  },
  setup () {
    // 所有站点集合
    const stationList = ref<any>([]);
    // 选中的tab
    const activeTab = ref<string>('1');
    // 下载弹窗
    const downloadVisible = ref<boolean>(false);
    // 数据列表
    const listData = ref<any>([]);
    // 日期格式参数格式
    const paramFormat = ref<string>('YYYYMMDDHH');
    // 污染物类型
    const param = ref<string>('pm25');
    // 所选站点
    const stations = ref<any>([]);
    // 下载chart图表
    const isDownloadChart = ref<boolean>(false);
    // 表格类型，1：单类型；2-单站点
    const tableType = ref<number>(1);

    /**
     * 获取数据
     * @param {any} value 数据
     * @return {void}
     */
    const getListData = (value:any): void => {
      if (tableType.value === 1) {
        listData.value = value?.listData;
      } else {
        listData.value = value?.listData.slice().reverse();
      }
      paramFormat.value = value?.paramFormat;
    };

    /**
     * @method changeStationType
     * @param {any} value 类型
     * @return {void} 切换
     */
    const changeStationType = (value:any): void => {
      stationList.value = value?.stationList;
      stations.value = value?.stations;
    };

    /**
     * @method handleDownload
     * @return {void} 下载弹窗
     */
    const handleDownload = ():void => {
      downloadVisible.value = true;
    };

    /**
     * @method downloadChart
     * @return {void} 下载
     */
    const downloadChart = ():void => {
      isDownloadChart.value = true;
    };

    /**
     * @method setParams
     * @param {string} val 子组件传值
     * @return {void} 设置产品类型
     */
    const setParams = (val: string):void => {
      param.value = val;
    };

    const setTableType = (type:number) => {
      tableType.value = type;
    };

    /**
     * @method hadDownloadChart
     * @return {void} 已下载
     */
    const hadDownloadChart = ():void => {
      isDownloadChart.value = false;
    };

    const cancal = (): void => {
      downloadVisible.value = false;
    };

    const save = (info: any): void => {
      downloadVisible.value = false;
    };

    return {
      locale,
      stationList,
      activeTab,
      downloadVisible,
      listData,
      paramFormat,
      param,
      stations,
      isDownloadChart,
      tableType,
      handleDownload,
      cancal,
      save,
      getListData,
      changeStationType,
      setParams,
      setTableType,
      downloadChart,
      hadDownloadChart,
    };
  },
});
